<template>
  <transition>
    <div>
      Taking Control over SessionID {{ sessionId }}
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { Channel } from 'channelx';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { logAction } from '@/shared/services/actionLog/ActionLogService';
import { ActionLogAction } from '@/shared/services/actionLog/ActionLogEntry';
import { AccessEvent } from '@/app.manager/events-manager/events/AccessEvent';
import { Channels } from '@/app.manager/events-manager/Channels';
import { authService } from '@/shared/services';

const eventsChannel = Channel.use(Channels.eventsChannel);

function loggedIn() {
  logAction({ action: ActionLogAction.loggedIn });

  eventsChannel.publish({ eventName: AccessEvent.LOGGED_IN });
}

const props = defineProps({
  sessionId: {
    type: String,
    required: true,
    default: null,
  },
});

onMounted(async () => {
  const { sessionId } = useRoute().params;

  authService.setControlledMode();
  authService.setSessionId(sessionId as string);

  loggedIn();
});

</script>

<style lang="less" scoped>
  div {
    color: red;
  }
</style>
